<template>
    <div class="IsGiftCheckbox">
      <ValidationProvider
        v-if="getIsGift"
        :rules="{ required: { allowFalse: false } }"
        class="additionalForm__agreements" name="isGiftChecked"
        ref="isGiftChecked"
        tag="div"
        v-slot="{ errors }">

        <div>
          <label class="checkbox-inline required" :class="errors.length > 0 ? 'invalid' : ''">
            <input
              class="dl-checked"
              name="isGiftChecked"
              type="checkbox"
              v-model="isGiftChecked" >
            Oświadczam, że zakupione produkty wykorzystam na cele socjalne pracowników lub wynagrodzenia. Jeżeli chcesz nagrodzić klienta, kontrahenta lub partnera biznesowego w ramach promocji sprzedaży skorzystaj z
            <b v-if="alternativeProduct">
              <a :href="alternativeProduct.href" :target="alternativeProduct.target || '_self'">{{ alternativeProduct.label }}</a>
            </b>
          </label>
        </div>
        <ul class="errors">
          <li :key="idx" class="text-danger" v-for="(error,idx) in errors">{{ error }}</li>
        </ul>
      </ValidationProvider>
    </div>
</template>

<script>
import { checkProductsIsGift } from '@/utils/categoryUtils';

const alternativeProductGroups = [
  {
    href: '/katalog/karta-magnetyczna-pluxee-nagroda-na-raz/formularz',
    label: 'karty magnetycznej Pluxee Nagroda na raz!',
    ids: [30071, 30192, 30305, 30937],
  },
  {
    href: '/katalog/karta-wirtualna-pluxee-nagroda-na-raz/formularz',
    label: 'karty wirtualnej Pluxee Nagroda na raz!',
    ids: [30174, 30143],
  },
  {
    href: '/katalog/karta-wirtualna-pluxee-nagroda-na-maxa/formularz',
    label: 'karty wirtualnej Pluxee Nagroda na maxa!',
    ids: [30675],
  },
  {
    href: '/katalog/karta-zblizeniowa-pluxee-nagroda-na-maxa/formularz',
    label: 'karty zbliżeniowej Pluxee Nagroda na maxa!',
    ids: [29833, 30195, 30702],
  },
  {
    href: 'https://www.pluxee.pl/wszystkie-produkty/#nagroda ',
    label: 'Karty Pluxee Nagroda',
    target: '_blank',
    ids: [30126],
  },
  {
    href: '/katalog/kupon-pluxee-nagroda/formularz ',
    label: 'Kuponu Pluxee Nagroda',
    ids: [28593, 28294, 28295, 28296],
  },
];
export default {
  name: 'Isgiftcheckbox',
  computed: {
    alternativeProduct() {
      return alternativeProductGroups.find(group => group.ids.includes(this.productId));
    },
    getIsGift() {
      return checkProductsIsGift(this.$store.state.products.all.products[0]);
    },
    productId() {
      const { idproducts } = this.$store.state.products.all.products[0];
      return idproducts;
    },
  },
};
</script>
